import React, {useState} from 'react';
import ReactDOM from 'react-dom';

function CustomCheckbox({checked, name, onChange}) {
    const [isCheck, setIsChecked] = useState(checked)

    const check = () => {
        setIsChecked(!isCheck)

        if(onChange) onChange(!isCheck)
    }
    return (
        <div className="custom-checkbox">
            <div className={["box", isCheck ? 'checked' : null].join(' ')}
                onClick={check}
            ><div className="inside-box">&nbsp;</div></div>
            <input type="checkbox" name={name} checked={isCheck} readOnly className="checkbox-input" />
        </div>
    );
}

export default CustomCheckbox;

if (document.getElementsByTagName('custom-checkbox')) {

    const elements = document.getElementsByTagName('custom-checkbox')
    console.log(elements)

    for(let elm of elements) {
        const check = elm.attributes['checked'] ? elm.sttributes['checked'].value : false
        const name = elm.attributes['name'].value
        ReactDOM.render(<CustomCheckbox checked={check == '1' || check == 'true' ? true : false} name={name}  />, elm)
    }
    // ReactDOM.render(<Example />, document.getElementById('example'));
}
